var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeopen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9731 16.7182C15.1303 16.7182 16.8791 14.9694 16.8791 12.8121C16.8791 10.6549 15.1303 8.90613 12.9731 8.90613C10.8159 8.90613 9.06707 10.6549 9.06707 12.8121C9.06707 14.9694 10.8159 16.7182 12.9731 16.7182Z",
    fill: "#A8A8A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.124 5C7.5774 5 3.61451 9.14186 2.22254 11.831C1.94987 12.3578 1.91931 12.9758 2.1779 13.5096C3.48075 16.1992 7.82864 20.3236 12.8235 20.3236C19.0206 20.3236 22.4561 16.4223 23.7921 13.734C24.1252 13.0637 24.0853 12.2761 23.7039 11.632C22.0657 8.86576 18.2977 5 13.124 5ZM18.6819 12.812C18.6819 15.9649 16.126 18.5208 12.9731 18.5208C9.82024 18.5208 7.26432 15.9649 7.26432 12.812C7.26432 9.6591 9.82024 7.10319 12.9731 7.10319C16.126 7.10319 18.6819 9.6591 18.6819 12.812Z",
    fill: "#A8A8A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeopen);
export default __webpack_public_path__ + "static/media/eyeopen.1b813acdb197291c1aa0aa58b58e75f7.svg";
export { ForwardRef as ReactComponent };